module.exports = __webpack_public_path__ + "img/logo-en-left-dark.19384f5.svg";